import { useState, useCallback } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import BayModal from '../../../BayModal';
import EditAdsAndLeads from '../Widgets/AdsAndLeads/EditAdsAndLeads';
import EditBanner from '../Widgets/Banner/EditBanner';
import EditCrm from '../Widgets/Crm/EditCrm';
import EditFinancial from '../Widgets/Financial/EditFinancial';
import EditHeader from '../Widgets/Header/EditHeader';
import EditLandingPages from '../Widgets/LandingPages/EditLandingPages';
import EditListings from '../Widgets/Listings/EditListings';
import EditListingsSmc from '../Widgets/ListingsSmc/EditListingsSmc';
import EditMarketing from '../Widgets/Marketing/EditMarketing';
import EditOtherlinks from '../Widgets/OtherLinks/EditOtherlinks';
import EditWebsites from '../Widgets/Websites/EditWebsites';

import './EditWidget.scss';

interface EditWidgetProps {
	t: (key: string) => string;
	show: boolean;
	onHide: (widgetId: string, action: string, updatedWidgets?: any) => void;
	widgetDetails: any;
	editModalInputFields?: any;
	setEditModalInputFields?: (fields: any) => void;
	setIsInPreviewMode?: (preview: boolean) => void;
	setWidgetCustomizationData?: (data: any) => void;
	setHeaderImageUrl?: any;
	widgetCustomizationData?: any;
	headerWidgetImageUrl?: string;
	headerWidgetTitle?: string;
	headerWidgetDescription?: string;
	widgetFinishStatus?: any;
	setWidgetFinishStatus?: (status: any) => void;
	bannerConfig?: any;
	defaultWidgetStyles?: any;
	bannerImageUrl?: string;
	setBannerImageUrl?: any;
	setSnackbar?: (snackbar: any) => void;
	widgetDrawerThemeSettings?: any;
	selectLaunchpadSettingsData?: any;
	handleLinkClick?: any;
}

const EditWidget = ({
	t,
	show,
	onHide,
	widgetDetails,
	editModalInputFields = () => {},
	setEditModalInputFields = () => {},
	setIsInPreviewMode = () => {},
	setWidgetCustomizationData = () => {},
	setHeaderImageUrl = () => {},
	widgetCustomizationData = {},
	headerWidgetImageUrl = '',
	headerWidgetTitle = '',
	headerWidgetDescription = '',
	widgetFinishStatus = {},
	setWidgetFinishStatus = () => {},
	bannerConfig = {},
	defaultWidgetStyles = {},
	bannerImageUrl = '',
	setBannerImageUrl = () => {},
	setSnackbar = () => {},
	widgetDrawerThemeSettings = {},
	selectLaunchpadSettingsData,
	handleLinkClick = () => {},
}: EditWidgetProps) => {
	const launchpadSettingsData = useSelector(selectLaunchpadSettingsData);

	const [widgetColorCodes, setWidgetColorCodes] = useState<Record<string, any>>({});
	const [editLinkName, setEditLinkName] = useState(
		widgetCustomizationData?.widgets?.['widget-otherLinks']?.sections
			?.firstTabLinks?.options?.[0]?.label || 'Example Link',
	);
	const [settingsDefaultClicked, setSettingsDefaultClicked] = useState<Record<string, boolean>>({});
	const [urlValidationState, setUrlValidationState] = useState<Record<string, any>>({});
	const [urlLoadingState, setUrlLoadingState] = useState<Record<string, boolean>>({});

	const handleColorCodesChange = useCallback((newColorCodes: any, widgetId: string) => {
		setWidgetColorCodes((prevState) => ({
			...prevState,
			[widgetId]: newColorCodes,
		}));
	}, []);

	const renderModalContent = () => {
		switch (widgetDetails?.id) {
			case 'widget-header':
				return (
					<EditHeader
						editModalInputFields={editModalInputFields}
						headerWidgetDescription={headerWidgetDescription}
						headerWidgetImageUrl={headerWidgetImageUrl}
						headerWidgetTitle={headerWidgetTitle}
						setEditModalInputFields={setEditModalInputFields}
						setHeaderImageUrl={setHeaderImageUrl}
						setWidgetFinishStatus={setWidgetFinishStatus}
						t={t}
						widgetCustomizationData={widgetCustomizationData}
						widgetFinishStatus={widgetFinishStatus}
						widgetId={widgetDetails?.id}
					/>
				);
			case 'widget-marketing':
				return (
					<EditMarketing
						defaultWidgetStyles={defaultWidgetStyles}
						drawerThemeSettings={launchpadSettingsData?.drawerThemeSettings}
						editModalInputFields={editModalInputFields}
						editModalOpen={show}
						handleLinkClick={handleLinkClick}
						setEditModalInputFields={setEditModalInputFields}
						setSettingsDefaultClicked={setSettingsDefaultClicked}
						t={t}
						widgetCustomizationData={widgetCustomizationData}
						widgetDrawerThemeSettings={widgetDrawerThemeSettings}
						widgetFinishStatus={widgetFinishStatus}
						widgetId={widgetDetails?.id}
						onColorCodesChange={handleColorCodesChange}
					/>
				);
			case 'widget-banner':
				return (
					<EditBanner
						bannerConfig={bannerConfig}
						bannerImageUrl={bannerImageUrl}
						editModalInputFields={editModalInputFields}
						setBannerImageUrl={setBannerImageUrl}
						setEditModalInputFields={setEditModalInputFields}
						setWidgetCustomizationData={setWidgetCustomizationData}
						setWidgetFinishStatus={setWidgetFinishStatus}
						t={t}
						widgetCustomizationData={widgetCustomizationData}
						widgetFinishStatus={widgetFinishStatus}
						widgetId={widgetDetails?.id}
					/>
				);
			case 'widget-crm':
				return (
					<EditCrm
						defaultWidgetStyles={defaultWidgetStyles}
						drawerThemeSettings={launchpadSettingsData?.drawerThemeSettings}
						editModalInputFields={editModalInputFields}
						editModalOpen={show}
						handleLinkClick={handleLinkClick}
						setEditModalInputFields={setEditModalInputFields}
						setSettingsDefaultClicked={setSettingsDefaultClicked}
						setWidgetCustomizationData={setWidgetCustomizationData}
						setWidgetFinishStatus={setWidgetFinishStatus}
						t={t}
						widgetCustomizationData={widgetCustomizationData}
						widgetDrawerThemeSettings={widgetDrawerThemeSettings}
						widgetFinishStatus={widgetFinishStatus}
						widgetId={widgetDetails?.id}
						onColorCodesChange={handleColorCodesChange}
					/>
				);
			case 'widget-listings':
				return (
					<EditListings
						defaultWidgetStyles={defaultWidgetStyles}
						drawerThemeSettings={launchpadSettingsData?.drawerThemeSettings}
						editModalInputFields={editModalInputFields}
						editModalOpen={show}
						handleLinkClick={handleLinkClick}
						setEditModalInputFields={setEditModalInputFields}
						setSettingsDefaultClicked={setSettingsDefaultClicked}
						setWidgetCustomizationData={setWidgetCustomizationData}
						setWidgetFinishStatus={setWidgetFinishStatus}
						t={t}
						widgetCustomizationData={widgetCustomizationData}
						widgetDrawerThemeSettings={widgetDrawerThemeSettings}
						widgetFinishStatus={widgetFinishStatus}
						widgetId={widgetDetails?.id}
						onColorCodesChange={handleColorCodesChange}
					/>
				);
			case 'widget-websites':
				return (
					<EditWebsites
						defaultWidgetStyles={defaultWidgetStyles}
						drawerThemeSettings={launchpadSettingsData?.drawerThemeSettings}
						editModalInputFields={editModalInputFields}
						editModalOpen={show}
						handleLinkClick={handleLinkClick}
						setEditModalInputFields={setEditModalInputFields}
						setSettingsDefaultClicked={setSettingsDefaultClicked}
						setWidgetCustomizationData={setWidgetCustomizationData}
						setWidgetFinishStatus={setWidgetFinishStatus}
						t={t}
						widgetCustomizationData={widgetCustomizationData}
						widgetDrawerThemeSettings={widgetDrawerThemeSettings}
						widgetFinishStatus={widgetFinishStatus}
						widgetId={widgetDetails?.id}
						onColorCodesChange={handleColorCodesChange}
					/>
				);
			case 'widget-financial':
				return (
					<EditFinancial
						defaultWidgetStyles={defaultWidgetStyles}
						drawerThemeSettings={launchpadSettingsData?.drawerThemeSettings}
						editModalInputFields={editModalInputFields}
						editModalOpen={show}
						handleLinkClick={handleLinkClick}
						setEditModalInputFields={setEditModalInputFields}
						setSettingsDefaultClicked={setSettingsDefaultClicked}
						setWidgetCustomizationData={setWidgetCustomizationData}
						setWidgetFinishStatus={setWidgetFinishStatus}
						t={t}
						widgetCustomizationData={widgetCustomizationData}
						widgetDrawerThemeSettings={widgetDrawerThemeSettings}
						widgetFinishStatus={widgetFinishStatus}
						widgetId={widgetDetails?.id}
						onColorCodesChange={handleColorCodesChange}
					/>
				);
			case 'widget-otherLinks':
				return (
					<EditOtherlinks
						defaultWidgetStyles={defaultWidgetStyles}
						editLinkName={editLinkName}
						editModalInputFields={editModalInputFields}
						editModalOpen={show}
						handleLinkClick={handleLinkClick}
						launchpadSettingsData={launchpadSettingsData}
						setEditLinkName={setEditLinkName}
						setEditModalInputFields={setEditModalInputFields}
						setUrlLoadingState={setUrlLoadingState}
						setUrlValidationState={setUrlValidationState}
						setWidgetCustomizationData={setWidgetCustomizationData}
						setWidgetFinishStatus={setWidgetFinishStatus}
						t={t}
						urlLoadingState={urlLoadingState}
						urlValidationState={urlValidationState}
						widgetCustomizationData={widgetCustomizationData}
						widgetFinishStatus={widgetFinishStatus}
						widgetId={widgetDetails?.id}
						onColorCodesChange={handleColorCodesChange}
					/>
				);
			case 'widget-adsAndLeads':
				return (
					<EditAdsAndLeads
						defaultWidgetStyles={defaultWidgetStyles}
						drawerThemeSettings={launchpadSettingsData?.drawerThemeSettings}
						editModalInputFields={editModalInputFields}
						editModalOpen={show}
						handleLinkClick={handleLinkClick}
						setEditModalInputFields={setEditModalInputFields}
						setSettingsDefaultClicked={setSettingsDefaultClicked}
						setWidgetCustomizationData={setWidgetCustomizationData}
						setWidgetFinishStatus={setWidgetFinishStatus}
						t={t}
						widgetCustomizationData={widgetCustomizationData}
						widgetDrawerThemeSettings={widgetDrawerThemeSettings}
						widgetFinishStatus={widgetFinishStatus}
						widgetId={widgetDetails?.id}
						onColorCodesChange={handleColorCodesChange}
					/>
				);
			case 'widget-listingsSmc':
				return (
					<EditListingsSmc
						defaultWidgetStyles={defaultWidgetStyles}
						drawerThemeSettings={launchpadSettingsData?.drawerThemeSettings}
						editModalInputFields={editModalInputFields}
						editModalOpen={show}
						handleLinkClick={handleLinkClick}
						setEditModalInputFields={setEditModalInputFields}
						setSettingsDefaultClicked={setSettingsDefaultClicked}
						setWidgetCustomizationData={setWidgetCustomizationData}
						setWidgetFinishStatus={setWidgetFinishStatus}
						t={t}
						widgetCustomizationData={widgetCustomizationData}
						widgetDrawerThemeSettings={widgetDrawerThemeSettings}
						widgetFinishStatus={widgetFinishStatus}
						widgetId={widgetDetails?.id}
						onColorCodesChange={handleColorCodesChange}
					/>
				);
			case 'widget-landingPages':
				return (
					<EditLandingPages
						defaultWidgetStyles={defaultWidgetStyles}
						drawerThemeSettings={launchpadSettingsData?.drawerThemeSettings}
						editModalInputFields={editModalInputFields}
						editModalOpen={show}
						handleLinkClick={handleLinkClick}
						setEditModalInputFields={setEditModalInputFields}
						setSettingsDefaultClicked={setSettingsDefaultClicked}
						setWidgetCustomizationData={setWidgetCustomizationData}
						setWidgetFinishStatus={setWidgetFinishStatus}
						t={t}
						widgetCustomizationData={widgetCustomizationData}
						widgetDrawerThemeSettings={widgetDrawerThemeSettings}
						widgetFinishStatus={widgetFinishStatus}
						widgetId={widgetDetails?.id}
						onColorCodesChange={handleColorCodesChange}
					/>
				);
			default:
				return null;
		}
	};

	const handleFinish = () => {
		const updatedWidgets = { ...widgetCustomizationData.widgets };

		if (widgetDetails.id === 'widget-header') {
			const updatedHeaderImage =
				editModalInputFields?.[widgetDetails.id]?.headerImage;
			if (!updatedHeaderImage) {
				setHeaderImageUrl(null);
			}
		}

		setEditModalInputFields((prevFields: any) => ({
			...prevFields,
			[widgetDetails.id]: {
				...prevFields[widgetDetails.id],
				allowWidgetCustomization: settingsDefaultClicked?.[widgetDetails.id],
			},
		}));

		const needsColorCodes = [
			'widget-marketing',
			'widget-crm',
			'widget-listings',
			'widget-websites',
			'widget-financial',
			'widget-adsAndLeads',
			'widget-listingsSmc',
			'widget-landingPages',
		].includes(widgetDetails.id);

		updatedWidgets[widgetDetails.id] = {
			...editModalInputFields?.[widgetDetails.id],
			...(widgetDetails.id === 'widget-header'
				? {
						headerImage: editModalInputFields?.[widgetDetails.id]?.headerImage,
						headerTitle: editModalInputFields?.[widgetDetails.id]?.headerTitle,
						headerTitleDescription:
							editModalInputFields?.[widgetDetails.id]?.headerSubtitle,
					}
				: {}),
			...(needsColorCodes && {
				iconColor: widgetColorCodes?.[widgetDetails.id]?.iconColor,
				iconBgColor: widgetColorCodes?.[widgetDetails.id]?.iconBgColor,
				linkColor: settingsDefaultClicked?.[widgetDetails.id]
					? editModalInputFields?.[widgetDetails.id]?.linkColor
					: widgetFinishStatus?.[widgetDetails.id]
						? widgetCustomizationData?.linkColor
						: editModalInputFields?.[widgetDetails.id]?.linkColor,
				allowWidgetCustomization: settingsDefaultClicked?.[widgetDetails.id],
			}),
		};

		setWidgetCustomizationData((prevState: any) => ({
			...prevState,
			widgets: { ...prevState?.widgets, ...updatedWidgets },
		}));

		setWidgetFinishStatus((prevState: any) => ({
			...prevState,
			[widgetDetails.id]: true,
		}));

		setIsInPreviewMode(true);

		onHide(widgetDetails?.id, 'finish', updatedWidgets);

		setSnackbar({
			show: true,
			description: t('customizationAppliedSuccessfully'),
		});
	};

	const isInvalidWidgetInput = (input: any) => {
		const visibleLinks = input?.links?.filter((link: any) => link.isVisible).length;

		return (
			!input?.headerTitle ||
			input.headerTitle.length > 16 ||
			!input?.headerTitleDescription ||
			input.headerTitleDescription.length > 36 ||
			visibleLinks < 2 ||
			visibleLinks > 5
		);
	};

	const getIsFinishBtnDisabled = () => {
		const input = editModalInputFields?.[widgetDetails.id];

		const isTitleInvalid = !input?.headerTitle || input.headerTitle.length > 16;

		let hasInvalidLinks = false;

		if (input?.sections && Array.isArray(input?.sections)) {
			hasInvalidLinks = input?.sections?.some((section: any) =>
				section?.options?.some(
					(option: any) => !option?.links?.some((link: any) => link?.isVisible),
				)
			);
		} else if (input?.sections && typeof input?.sections === 'object') {
			hasInvalidLinks = Object.entries(input?.sections)?.some(
				(option: any) => !option?.links?.some((link: any) => link?.isVisible)
			);
		}

		const hasInvalidSection = Object.entries(input?.sections || {}).some(
			([tabKey, section]: [string, any]) => {
				if (tabKey === 'firstTabLinks') {
					return (
						!section?.sectionTitle ||
						section?.sectionTitle?.length > 16 ||
						section?.options?.some(
							(option: any) => !option.path || !editLinkName,
						)
					);
				} else if (
					tabKey === 'secondTabLinks' ||
					tabKey === 'thirdTabLinks'
				) {
					return (
						!section?.sectionTitle || section?.sectionTitle?.length > 16
					);
				}
				return false;
			},
		);

		const hasInvalidUrl = Object.entries(urlValidationState).some(
			([key, validation]: [string, any]) =>
				key.includes('firstTabLinks') && validation?.isValid === false,
		);

		switch (widgetDetails.id) {
			case 'widget-header':
				return (
					input?.headerTitle?.length > 16 || input?.headerSubtitle?.length > 100
				);

			case 'widget-marketing':
				return isTitleInvalid || hasInvalidLinks;

			case 'widget-banner':
				return (
					!input?.bannerHoverText ||
					input.bannerHoverText.length > 20 ||
					!input?.bannerHoverUrl
				);

			case 'widget-otherLinks':
				if (!input?.sections) return true;

				return hasInvalidSection || hasInvalidUrl;

			case 'widget-crm':
			case 'widget-listings':
			case 'widget-websites':
			case 'widget-financial':
			case 'widget-adsAndLeads':
			case 'widget-listingsSmc':
			case 'widget-landingPages':
				return isInvalidWidgetInput(input);

			default:
				return false;
		}
	};

	const isFinishBtnDisabled = getIsFinishBtnDisabled();

	return (
		<BayModal
			className="edit-widget-drawer"
			closeButton={true}
			footer={
				<Row className="w-100 justify-between">
					<Col className="ps-0">
						<Button
							variant="outline-secondary"
							onClick={() => onHide(widgetDetails?.id, 'close')}
						>
							{t('cancel')}
						</Button>
					</Col>
					<Col className="pe-0 d-flex justify-content-end align-items-center gap-3">
						<Button
							disabled={isFinishBtnDisabled}
							variant="primary"
							onClick={handleFinish}
						>
							{t('finish')}
						</Button>
					</Col>
				</Row>
			}
			height="100%"
			id="edit_widget_settings_drawer"
			show={show}
			title={widgetDetails?.editModalTitle || 'Edit'}
			onHideFunc={() => onHide(widgetDetails?.id, 'close')}
		>
			{renderModalContent()}
		</BayModal>
	);
};

export default EditWidget;
